import React from "react";
import * as Styled from "./styles";
import { useTranslation } from "react-i18next";

interface ReservationDateProps {
  name?: string;
  dateName?: string;
  date: any;
  time?: any;
  onChange: any;
  placeholder?: string;
  timeInterval?: any;
}

const ReservationDate = (props: ReservationDateProps) => {
  const { t } = useTranslation();
  return (
    <Styled.DateItem>
      <Styled.DateName>{props.name}</Styled.DateName>
      {props.time ? (
        <>
          <Styled.CustomDate
            name={props.dateName}
            value={props.date?.format(`a hh:mm`)}
            placeholderText={t("common.selectTime")}
            onChange={props.onChange}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={props.timeInterval ? props.timeInterval : 30}
          />
        </>
      ) : (
        <>
          <Styled.CustomDate
            name={props.dateName}
            value={props.date?.format("YYYY.MM.DD")}
            placeholderText={t("common.selectDay")}
            onChange={props.onChange}
          />
        </>
      )}
    </Styled.DateItem>
  );
};

export default ReservationDate;
